import { render } from "./TheHeaderNaviOnAdmin.vue?vue&type=template&id=48184490&scoped=true&ts=true"
import script from "./TheHeaderNaviOnAdmin.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviOnAdmin.vue?vue&type=script&lang=ts"

import "./TheHeaderNaviOnAdmin.vue?vue&type=style&index=0&id=48184490&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48184490"]])

export default __exports__